export default __webpack_public_path__ + "static/media/inst_juego5.9ecdebb6.png";